export default "/images/google_display.png?dabe3cbcd259e375f3ed8b20d544c2e0";